<script lang="ts" module>
  import type { Collection } from '@agapi/mlc-core';

  export interface StoryItemProps extends Collection {}
</script>

<script lang="ts">
  import { page } from '$app/state';

  import { Card, CardImage, CardContent } from '@agapi/ui/card';
  import { Image } from '@agapi/ui/image';

  import { storyItemStyles } from './story-item.styles';
  import { rewriteUrl } from '../../utils';

  const classes = storyItemStyles.raw();

  const { name, path, imageUrl }: StoryItemProps = $props();
</script>

{#if path}
  <a href={rewriteUrl(page, path)}>
    <Card css={classes.root} colorVariant="transparent">
      <CardImage
      css={classes.imageWrapper}
      >
        {#if imageUrl}
          <Image
            src={imageUrl}
            alt={"Bild för " + (name || "Story image")}
            width={89}
            height={89}
            fetchpriority="high"
            background={imageUrl + '?width=16'}
          />
        {/if}
      </CardImage>
      {#if name}
        <CardContent css={classes.label}>
          {name}
        </CardContent>
      {/if}
    </Card>
  </a>
{:else}
  <Card css={classes.root}>
    <CardImage
    src={imageUrl}
    alt={"Bild för " + (name || "")}
    width={89}
    height={89}
    background={imageUrl + '?width=16&aspect_ratio=16:16&blur=100'}
    aspectRatio={1 / 1}
    />
    {#if name}
    <CardContent css={classes.label}>
      {name}
    </CardContent>
    {/if}
  </Card>
{/if}
